/**
 * Calculates the EOY share price
 * @param previousSharePrice - Previous share price
 * @param expectedAnnualStockAppreciation - Expected annual stock appreciation
 * @returns Share price
 */
export const getSharePrice = (
  previousSharePrice: number,
  expectedAnnualStockAppreciation: number
) => {
  const expectedAnnualStockAppreciationPercentage = expectedAnnualStockAppreciation / 100;

  return previousSharePrice + previousSharePrice * expectedAnnualStockAppreciationPercentage;
};
